export default "images/travelfox_white_notext.svg";